import React from "react";
import { SlackThread } from "src/models/SlackThread";
import { AdminService } from "src/services/AdminService";
import NanoClamp from "nanoclamp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import { Row, Col, Button } from "reactstrap";
import LoadingComponent from "src/components/General/Loading";

export const SlackLatest: React.FunctionComponent = () => {
  const [threads, setThreads] = React.useState<SlackThread[]>(null);
  const [loading, setLoading] = React.useState(true);
  const [viewAll, setViewAll] = React.useState(false);
  const truncView = 3;
  React.useEffect(() => {
    AdminService.getLatestSlack()
      .then((threads) => {
        setLoading(false);
        return setThreads(threads);
      })
      .catch((error) => {
        console.error(error);
      });
    return (): void => {};
  }, []);
  const showAll = (): void => {
    setViewAll(true);
  };
  return (
    <div className="slack-latest">
      <Row className="mt-5">
        <Col xs="12">
          <h5 className="underline cta fw400">Latest Provider Discussion</h5>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            Join our Provider Discussion on&nbsp;
            <a
              href="https://join.slack.com/t/psychedelic-support/shared_invite/zt-dbxxv8qp-UC1wwhclN~1ZyFXOr4Xftg"
              target="_blank"
              rel="noreferrer nofollow noopener"
            >
              Slack
            </a>
          </div>
        </Col>
      </Row>
      <div className="mt-4">
        {loading === true && <LoadingComponent />}
        {loading === false && (
          <div>
            {threads &&
              threads.slice(0, viewAll ? threads.length : truncView).map((t, i) => {
                return (
                  <a
                    href="https://join.slack.com/t/psychedelic-support/shared_invite/zt-dbxxv8qp-UC1wwhclN~1ZyFXOr4Xftg"
                    target="_blank"
                    rel="noreferrer nofollow noopener"
                    key={i}
                  >
                    <div className="thread">
                      <div className="header">
                        <div className="channel">#{t.channel}</div>
                        <div className="ts">{new Date(t.ts).toLocaleString()}</div>
                      </div>
                      <div className="msg-wrapper">
                        <NanoClamp className="msg" text={t.text} lines={2} />
                        {t.reactions > 0 && (
                          <div className="reactions">
                            <FontAwesomeIcon icon={faComments} />
                          </div>
                        )}
                      </div>
                    </div>
                  </a>
                );
              })}
            {viewAll === false && (
              <div className="cursor-pointer mt-3 mb-2 text-center" onClick={showAll}>
                <Button color="secondary">See More</Button>
              </div>
            )}
            {viewAll === true && (
              <div className="cursor-pointer mt-3 mb-2 text-center">
                <a
                  href="https://join.slack.com/t/psychedelic-support/shared_invite/zt-dbxxv8qp-UC1wwhclN~1ZyFXOr4Xftg"
                  target="_blank"
                  rel="noreferrer nofollow noopener"
                >
                  <Button color="secondary">See All</Button>
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
